import { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { logger } from '../utils/logger';

// Mirror of backend DEFAULT_CONTEXT_BATCHES — instant paint before fetch.
export const DEFAULT_CONTEXT_BATCHES = [
  { key: 'CALLS', label: 'Calls', color: 'var(--pd-green)' },
  { key: 'REVIEWS', label: 'Reviews', color: 'var(--pd-warning)' },
  { key: 'DEEP_WORK', label: 'Deep Work', color: 'var(--pd-focus)' },
  { key: 'ADMIN', label: 'Admin', color: 'var(--pd-muted)' },
  { key: 'ERRANDS', label: 'Errands', color: '#B45309' },
  { key: 'APPROVALS', label: 'Approvals', color: 'var(--pd-crimson)' },
  { key: 'CREATIVE', label: 'Creative', color: '#7C3AED' },
];

/**
 * User-customisable context batches (Settings → Context batches).
 * Refreshes automatically when the settings panel saves (via the
 * `polkdesq:context-batches-updated` window event).
 */
export function useContextBatches() {
  const [batches, setBatches] = useState(DEFAULT_CONTEXT_BATCHES);
  const [isCustom, setIsCustom] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchBatches = useCallback(async () => {
    try {
      const res = await api.get('/settings/context-batches');
      if (Array.isArray(res.data?.batches)) {
        setBatches(res.data.batches);
        setIsCustom(Boolean(res.data.isCustom));
      }
    } catch (err) {
      logger.error('Context batches fetch failed:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchBatches(); }, [fetchBatches]);

  useEffect(() => {
    const onUpdated = () => fetchBatches();
    window.addEventListener('polkdesq:context-batches-updated', onUpdated);
    return () => window.removeEventListener('polkdesq:context-batches-updated', onUpdated);
  }, [fetchBatches]);

  return { batches, isCustom, loading, refresh: fetchBatches };
}
